import { Exclude, plainToInstance } from 'class-transformer'
import { User } from '@core/entities/user'
import { Entity } from '@core/entities/entity'
import { IRegistersLinkableItem } from './IRegistersLinkableItem'

export class RegistersLinkableItem extends Entity<IRegistersLinkableItem> {
  id: number
  name: string
  createdBy?: User
  createdOn: string
  registerTemplate: {
    id: number
    name: string
  }

  @Exclude({ toPlainOnly: true })
  isSelected: boolean

  public static new(payload: unknown): RegistersLinkableItem {
    const entity = plainToInstance(RegistersLinkableItem, payload)

    return entity
  }

  public selectRegister(): void {
    this.isSelected = true
  }
}
